import { useForm } from "react-hook-form";
import z from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { authStore } from "../store/auth";
import {
  Box,
  Button,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { login } from "../api/auth";
import logo from "../assets/logo.png";
import Swal from "sweetalert2";

const schema = z.object({
  username: z.string().min(1, "กรอกชื่อผู้ใช้"),
  password: z.string().min(1, "กรอกรหัสผ่าน"),
});
type FormValues = z.infer<typeof schema>;

export default function LoginPage() {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>({
    resolver: zodResolver(schema),
  });

  const onSubmit = async (values: FormValues) => {
    try {
      const res = await login(values.username, values.password);
      authStore.setToken(res.token);
      localStorage.setItem("role", res.user.role);
      localStorage.setItem("roleName", res.user.roleName);
      window.location.href = "/";
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "เข้าสู่ระบบไม่สำเร็จ",
        text: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง",
        confirmButtonColor: "#d33",
        confirmButtonText: "ตกลง",
      });
    }
  };

  return (
    <Box
      minHeight="100vh"
      display="grid"
      sx={{ backgroundColor: "#FFF9E5", placeItems: "center" }}
    >
      <Paper
        sx={{
          p: 4,
          width: 480,
          borderTop: "8px solid #FEDC00",
          textAlign: "center",
        }}
        elevation={3}
      >
        {/* ✅ แสดง logo */}
        <Box
          component="img"
          src={logo}
          alt="Royal Park Logo"
          sx={{ width: 220, mb: 2, mx: "auto" }}
        />

        <Typography
          variant="h5"
          mb={2}
          sx={{ fontWeight: "bold", color: "#333" }}
        >
          เข้าสู่ระบบ
        </Typography>

        <Stack gap={2} component="form" onSubmit={handleSubmit(onSubmit)}>
          <TextField
            label="ชื่อผู้ใช้"
            {...register("username")}
            error={!!errors.username}
            helperText={errors.username?.message}
            fullWidth
          />

          <TextField
            label="รหัสผ่าน"
            type="password"
            {...register("password")}
            error={!!errors.password}
            helperText={errors.password?.message}
            fullWidth
          />

          <Button
            type="submit"
            disabled={isSubmitting}
            fullWidth
            sx={{
              mt: 1,
              backgroundColor: "#FEDC00",
              color: "#000",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#e5c800",
              },
            }}
          >
            เข้าสู่ระบบ
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
